import React from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import * as styles from './index.module.styl';

interface CheckBoxProps extends StandardProps {
  id: string;
  label: string;
  checked: boolean;
  value: string | number;
  htmlId?: string;
  inputClassName?: string;
  labelClassName?: string;
  labelContainerClassName?: string;
  errorMessage?:string;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void | Promise<void>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
}

// 複数選択のチェックボックス
export default function Checkbox(props: CheckBoxProps): JSX.Element {
  const {
    id,
    className,
    inputClassName,
    label,
    labelClassName,
    labelContainerClassName,
    htmlId = '',
    checked,
    value,
    errorMessage,
    onFocus,
    onChange,
  } = props;

  return (
    <div className={`${className} ${styles.cCheck}`}>
      <input
        id={htmlId || `${id}_${value}`}
        name={id}
        type="checkbox"
        checked={checked}
        className={inputClassName}
        data-gtm={`gtm-newcarform-${id}`}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
      />
      <label
        className={`${styles.cCheckRequired} ${labelClassName || ''}`}
        htmlFor={htmlId || `${id}_${value}`}
        aria-invalid={Boolean(errorMessage !== '')}
      >
        <span className={labelContainerClassName || ''}>
          <i className={styles.cCheckCheck} />
          {label}
        </span>
      </label>
    </div>
  );
}
